export const MODULE = "planner/personal-settings";

// The name the server stores each setting under.
export const SERVER_KEYS = {
  defaultTimeMinutes: "default_duration",
  weekStartsOn: "week_start",
  daysShown: "visible_weekdays",
  hoursShown: "hours_shown",
};
